import React, { useState } from "react";
import MainLayout from "../layout/MainLayout";
import Header from "../components/Header";
import { baseUrl } from "../redux/index";
import axios from "axios";
import { useSelector } from "react-redux";
import UnPaidCheckout from "./UnPaidCheckout";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Settings = ({ unPaid }) => {
  const [passType, setPassType] = useState({
    oldPassword: true,
    newPassword: true,
    confirmPassword: true,
  });
  const [pass, setPass] = useState({
    password: "",
    confirmPassword: "",
  });
  const [passwordError, setPasswordError] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [apiMessage, setApiMessage] = useState({ type: "", message: "" });
  const { userDetails } = useSelector((state) => state?.auth ?? []);
  const { userId } = userDetails;

  const togglePasswordVisibility = (field) => {
    setPassType((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChars = /[!@#$%^&*]/.test(password);

    if (password.length < minLength) {
      return "Password must be at least 8 characters long.";
    }
    if (!hasUpperCase) {
      return "Password must contain at least one uppercase letter.";
    }
    if (!hasLowerCase) {
      return "Password must contain at least one lowercase letter.";
    }
    if (!hasNumbers) {
      return "Password must contain at least one number.";
    }
    if (!hasSpecialChars) {
      return "Password must contain at least one special character.";
    }
    return "";
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPass((prev) => ({ ...prev, [name]: value }));

    if (name === "password") {
      const error = validatePassword(value);
      setPasswordError(error);
      setIsPasswordValid(!error);
    } else if (name === "confirmPassword") {
      setIsPasswordValid(value === pass.password && !passwordError);
    }
  };

  const handleSubmitPasswordChange = async (e) => {
    e.preventDefault();
    if (isPasswordValid) {
      try {
        const response = await axios.post(baseUrl + "/updatepassword", {
          userId: userId,
          oldPassword: e.target.old_password.value,
          newPassword: pass.password,
        });

        setApiMessage({
          type: "success",
          message: response.data.message,
        });

        // Clear form
        e.target.reset();
        setPass({ password: "", confirmPassword: "" });
      } catch (error) {
        setApiMessage({
          type: "error",
          message: error.response?.data?.message || "Failed to update password",
        });
      }
    }
  };

  return (
    <>
      <MainLayout>
        {unPaid ? (
          <UnPaidCheckout />
        ) : (
          <div className="flex flex-col justify-between gap-10 p-4 sm:p-8">
            <Header
              title={"Account Setting"}
              subTitle="Account"
              description={"Manage Your Account Settings Here"}
            />
            <hr />
            {apiMessage.message && (
              <div
                className={`p-4 rounded-xl ${
                  apiMessage.type === "success"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {apiMessage.message}
              </div>
            )}
            <form
              className="flex flex-col gap-5"
              onSubmit={handleSubmitPasswordChange}
            >
              <fieldset className="flex flex-col px-10 py-8 gap-8 border-2 rounded-xl">
                <legend className="font-bold">Update Password</legend>
                <div className="flex flex-col gap-2 relative">
                  <label className="">Old Password</label>
                  <div className="relative w-full sm:w-1/2">
                    <input
                      type={passType.oldPassword ? "password" : "text"}
                      placeholder="Enter your old password"
                      required
                      name="old_password"
                      className="w-full p-3 rounded-xl border-2 text-sm"
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-4"
                      onClick={() => togglePasswordVisibility("oldPassword")}
                    >
                      {passType.oldPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                </div>
                <div className="flex flex-col gap-2 relative">
                  <label className="">New Password</label>
                  <div className="relative w-full sm:w-1/2">
                    <input
                      type={passType.newPassword ? "password" : "text"}
                      placeholder="Enter your new password"
                      required
                      name="password"
                      className="w-full p-3 rounded-xl border-2 text-sm"
                      onChange={handlePasswordChange}
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-4"
                      onClick={() => togglePasswordVisibility("newPassword")}
                    >
                      {passType.newPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                  {passwordError && (
                    <p className="text-red-500">{passwordError}</p>
                  )}
                </div>
                <div className="flex flex-col gap-2 relative">
                  <label className="">Confirm Password</label>
                  <div className="relative w-full sm:w-1/2">
                    <input
                      type={passType.confirmPassword ? "password" : "text"}
                      placeholder="Please Confirm password"
                      required
                      name="confirmPassword"
                      className="w-full p-3 rounded-xl border-2 text-sm"
                      onChange={handlePasswordChange}
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-4"
                      onClick={() =>
                        togglePasswordVisibility("confirmPassword")
                      }
                    >
                      {passType.confirmPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                  {pass.password === pass.confirmPassword ? (
                    <p className="text-green-500">✅ Passwords match</p>
                  ) : (
                    <p className="text-red-500 ">🚫 Passwords do not match</p>
                  )}
                </div>
              </fieldset>
              <div className="px-8">
                <button
                  className="bg-purple-500 px-8 py-3 rounded-xl text-white hover:bg-purple-600"
                  type="submit"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        )}
      </MainLayout>
    </>
  );
};

export default Settings;
